<div class="fulfill-side-panel-scan">
  <div class="close-panel" (click)="closePanel()">
    <img src="../../../../../../../assets/images/left_chevron.png" alt="" />
  </div>
  <img src="../../../../../../assets/images/workspace/scan_order.png" alt="" />
  <p>{{ label }}</p>
  <div class="fulfill-side-panel-scan__action">
    <span style="width: 50%">
      <pdq-input
        class="scan_input"
        placeholder="Scan or enter label no."
        [autofocus]="true"
        [value]="searchString"
        (onKeyup)="setOrderId($event)"
        (onEnter)="scanOrder()"></pdq-input>

      <ng-template #scannedOrderMultipleResults> </ng-template>
    </span>

    <pdq-button
      class="fulfill-side-panel-scan__button"
      variant="light"
      label="Go"
      icon="scan"
      [loading]="isLoading"
      (onClick)="scanOrder()"></pdq-button>
  </div>
</div>
